const apiUrl = process.env.REACT_APP_API_URL
const webUrl = process.env.REACT_APP_WEB_APP_ROOT
const isProduction = process.env.NODE_ENV === 'production'

const fullWebUrl = isProduction ? `https://${webUrl}` : `http://${webUrl}`

export const OBVIO_WIDGET_LOADER_URL = `${fullWebUrl}/widget/obvio_widget_loader.gif`
export const OBVIO_WIDGET_GOOGLE_URL = `${fullWebUrl}/widget/icons/google.png`
export const OBVIO_WIDGET_APPLE_URL = `${fullWebUrl}/widget/icons/apple.png`
export const OBVIO_WIDGET_OUTLOOK_URL = `${fullWebUrl}/widget/icons/outlook.png`
export const OBVIO_WIDGET_YAHOO_URL = `${fullWebUrl}/widget/icons/yahoo.png`
export const OBVIO_WIDGET_API_BASE = `${apiUrl}/`
